import * as C from '../constants';
import * as THREE from 'three';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

export const useLights = (materials) => {
  if (materials) {
    const material = materials.light;
    material.visible = false;
  }

  return null;
};
